export default {
    routerName: '広告追加',
    routerNamePic: '画像カットアウト',
    ad: {
        adSpace: '広告位',
        id: 'ID',
        name: '広告名',
        description: '記述',
        thumb: 'サムネイル',
        image: '画像',
        link: '広告URL',
        sortOrder: 'ソート',
        hits: '閲覧量',
        category: '類別',
        hot: '人気',
        recommend: '推薦',
        recommendTop: '推薦TOP',
        topic: '話題',
        type: 'タイプ',
        typeImage: '画像',
        typeVideo: 'ビデオ',
        typeRadio: '音声',
        pattern: 'パターン',
        startTime: 'パターン開始日時',
        endTime: 'パターン終了日時',
        patternHits: 'パターン閲覧量',
        pDay: '日',
        pHits: '閲覧量',
        status: '状態',
        open: '有効',
        close: '無効',
    },
};
